const AgentOrderByOptions = {
    CreationDate: 1,
    Name: 2,
    Status: 3
};

export default AgentOrderByOptions;